import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Box from '../box/box.jsx';
import PeripheralTile from './peripheral-tile.jsx';
import Dots from './dots.jsx';

import refreshIcon from './icons/refresh.svg';

import styles from './connection-modal.css';

const ScanningStep = props => (
    <Box className={styles.body}>
        {props.isSerialport ? (
            <Box className={classNames(styles.bodyHeadArea)}>
                {props.title === 'arduinoNano' ? (
                    <React.Fragment>
                        <div className={styles.listAll}>
                            <FormattedMessage
                                defaultMessage="Processor"
                                description="Label for processor selection"
                                id="gui.connection.scanning.processor"
                            />
                        </div>
                        <div className={styles.checkBox}>
                            <select
                                value={props.selectedProcessor}
                                onChange={props.onProcessorChange}
                                style={{height: '20px', fontSize: '11px'}}
                            >
                                <option value="cpu=atmega328">ATmega328P</option>
                                <option value="cpu=atmega328old">ATmega328P Old Bootloader</option>
                            </select>
                        </div>
                    </React.Fragment>
                ) : null}
                <div
                    className={styles.listAll}
                    style={props.title === 'arduinoNano' ? {marginLeft: '20px'} : {}}
                >
                    <FormattedMessage
                        defaultMessage="Show all connectable devices"
                        description="Button in prompt for show all connectable devices"
                        id="gui.connection.scanning.listAll"
                    />
                </div>
                <div className={styles.checkBox}>
                    <input
                        type="checkbox"
                        name="hexform"
                        checked={props.isListAll}
                        onChange={props.onClickListAll}
                    />
                </div>
            </Box>
        ) : null}
        <Box className={styles.activityArea}>
            {props.scanning ? (
                props.peripheralList.length === 0 ? (
                    <div className={styles.activityAreaInfo}>
                        <div className={styles.centeredRow}>
                            <div className={styles.modernRadar}></div>
                            <div className={styles.scanningText}>
                                <FormattedMessage
                                    defaultMessage="Looking for devices"
                                    description="Text shown while scanning for devices"
                                    id="gui.connection.scanning.lookingforperipherals"
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={styles.peripheralTilePane}>
                        {props.peripheralList.map(peripheral =>
                            (<PeripheralTile
                                connectionSmallIconURL={props.connectionSmallIconURL}
                                key={peripheral.peripheralId}
                                name={peripheral.name}
                                peripheralId={peripheral.peripheralId}
                                rssi={peripheral.rssi}
                                isSerialport={props.isSerialport}
                                onConnecting={props.onConnecting}
                            />)
                        )}
                    </div>
                )
            ) : (
                <div className={styles.activityAreaInfo}>
                    <div className={styles.centeredRow}>
                        <div className={styles.emptyRadar}></div>
                        <div className={styles.scanningText} style={{ animation: 'none' }}>
                            <FormattedMessage
                                defaultMessage="No devices found"
                                description="Text shown when no devices could be found"
                                id="gui.connection.scanning.noPeripheralsFound"
                            />
                        </div>
                    </div>
                </div>
            )}
        </Box>
        <Box className={styles.bottomArea}>
            <Box className={classNames(styles.bottomAreaItem, styles.instructions)}>
                <FormattedMessage
                    defaultMessage="Select your device in the list above."
                    description="Prompt for choosing a device to connect to"
                    id="gui.connection.scanning.instructions"
                />
            </Box>
            <Dots
                className={styles.bottomAreaItem}
                counter={0}
                total={3}
            />
            <button
                className={classNames(styles.bottomAreaItem, styles.connectionButton)}
                onClick={props.onRefresh}
            >
                <FormattedMessage
                    defaultMessage="Refresh"
                    description="Button in prompt for starting a search"
                    id="gui.connection.search"
                />
                <img
                    className={styles.buttonIconRight}
                    src={refreshIcon}
                />
            </button>
        </Box>
    </Box>
);

ScanningStep.propTypes = {
    connectionSmallIconURL: PropTypes.string,
    isListAll: PropTypes.bool.isRequired,
    isSerialport: PropTypes.bool,
    onClickListAll: PropTypes.func.isRequired,
    onConnecting: PropTypes.func,
    onRefresh: PropTypes.func,
    selectedProcessor: PropTypes.string,
    onProcessorChange: PropTypes.func,
    peripheralList: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        rssi: PropTypes.number,
        peripheralId: PropTypes.string
    })),
    scanning: PropTypes.bool.isRequired
};

ScanningStep.defaultProps = {
    peripheralList: [],
    scanning: true,
    selectedProcessor: 'cpu=atmega328',
    onProcessorChange: () => {}
};

export default ScanningStep;
